import React from 'react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import QueryProvider from '@/contexts/Query';
import { ThemeProvider } from '@/contexts/Theme';
import { I18nProvider } from '@/contexts/I18n';
import { WcConfig } from '@/types/environment';
import AuthGate from '@/components/layout/AuthGate';

const App: React.FC<{
  wcconfig: WcConfig;
}> = ({ wcconfig }) => {
  return (
    <I18nProvider lang={wcconfig.lang}>
      <ThemeProvider>
        <QueryProvider>
          <>
            {wcconfig.env === 'dev' && <ReactQueryDevtools initialIsOpen={false} />}
            {/* AuthGate runs the health-check, so it must sit inside QueryProvider. */}
            <AuthGate />
          </>
        </QueryProvider>
      </ThemeProvider>
    </I18nProvider>
  );
};

export default App;
